import React, { useEffect,useState } from 'react';
import email from '../../assets/email.png';
import close from '../../assets/close.svg';
import info from '../../assets/info.png';

const EmailInbox = React.memo(({ simObj, setSimObj, updateReadStatus, closePopups, replaceVariables, popupLeft,setToggleSimulation, isWaitForMoreBids, setIsWaitForMoreBids,addSpaceAfterDot}) => {
  const shortMonthNames = [
    "", // Placeholder for the 0th index
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  const [activeIssue,setActiveIssue] = useState("");
  const [activeArtifactId,setActiveArtifactId] = useState(null);
  const btnStyle = {
    "color": "rgb(255, 255, 255)",
    "background-color": "rgb(178, 52, 123)",
    "padding": "4px 12px",
    "border-radius": "22px",
    "border": "1px solid transparent",
    "font-size": "14px",
    "cursor":"pointer",
    "margin": "4px 4px"
  }
  const onHandlerViewBids = () => {
    closePopups();
    let trigger = simObj?.dtiObj?.bid?.trigger;
    window.$("#decisionMain").find("div[role='tablist'] #tab_2").click();
    window.$("#placeOrderMain").find(".tab-item:first-child").click();
    if(!document.querySelector(".ui.accordion .title").classList.contains("active")){
      window.$(".ui.accordion .title").click();
    }
    window.$("#placeOrder").find("tr[supplierid]").css("background","#fff");
    window.$("#placeOrder").find("tr[supplierid='"+trigger.split("_")[1]+"']").css("background","#FBDFD6").attr({"tabindex":"-1"}).focus();
  }
  const onHandlerWaitForMoreBids = () => { 
    closePopups();
    setIsWaitForMoreBids(true);
    setToggleSimulation(true);
  }
  const onHandlerContinueBid = () => {
    closePopups();
    setToggleSimulation(true)
  } 
  const isOverflowing = (element) => {
    if(element){
      return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
    }
    return 0;
  }

  const markOverflowing = () => {
    let elements = document.querySelectorAll(".email-box .six.column ul li .left.floated")
    elements.forEach((element) => {
      if(isOverflowing(element)){
        element.classList.add("overflowing")
      }
    })
  }

  const handleButtonClick = (event) =>{
      setActiveArtifactId(event.currentTarget.id);
      updateReadStatus(event)
      // Find the first object where artifactid_id is not null
      let resultObject = null;
      for (const key in simObj?.dtiObj) {
          if (simObj?.dtiObj[key].aii !== null) {
              resultObject = simObj?.dtiObj[key];
              break;
          }
      }
     setActiveIssue(resultObject?.aii == event.currentTarget.id ? event.currentTarget.getAttribute("classification"): "")
  }
  const onHandlerCancelOrder = () => { 
    const trigger =
    simObj?.dtiObj?.delivery?.isDeliveryIssue ? simObj.dtiObj.delivery.trigger :
    simObj?.dtiObj?.labour?.isLabourIssue ? simObj.dtiObj.labour.trigger :
    simObj?.dtiObj?.quality?.isQualityIssue ? simObj.dtiObj.quality.trigger :
    "All";
    // let answer = window.confirm("Are you sure you want to cancel this order");
    // if (answer) {
    //   let supplierId = simObj?.dtiObj?.delivery?.trigger || simObj?.dtiObj?.labour?.trigger;  
    //     setSimObj((prevSimObj) => ({
    //         ...prevSimObj,
    //         ['actions']: {
    //             ...simObj?.actions,
    //             ['scmDecision']: {
    //                 ...simObj?.actions?.scmDecision,
    //                 ['cancelSupplerList']: [supplierId]
    //             }
    //         }
    //     }))

    //     // console.log(simObj?.actions?.scmDecision?.cancelSupplerList);
    // }
    closePopups();
    window.$("#decisionMain").find("div[role='tablist'] #tab_2").click();
    window.$("#placeOrderMain").find(".tab-item:first-child").click();
    setTimeout(()=>{
      window.$("#placeOrder").find("tr[supplierid]").css("background","#fff");
      window.$("#placeOrder").find("tr[sender='"+trigger+"']").css("background","#FBDFD6").attr({"tabindex":"-1"}).focus();
    },200)
}
  useEffect(() => {
    window.jQuery('.item').tab();
    if (document.querySelector(".email-box .ui.list .tab-item.active")) {
      document.querySelector(".email-box .ui.list .tab-item.active").click();
    }
  }, []);
  // useEffect(() => {
  //   document.querySelector(".popup-container .header-box h2").tabIndex = -1;
  //   document.querySelector(".popup-container .header-box h2").focus();
  // }, [])
  useEffect(()=>{
    if(simObj?.artifacts){
      markOverflowing();
    }
  },[simObj?.artifacts])
  useEffect(() => {
    if (simObj?.dtiObj?.bid?.isBidReceived && simObj?.dtiObj?.bid?.artifactid_id) {
      setActiveIssue("BID_RESPONSE");
      !activeArtifactId && setActiveArtifactId(simObj?.dtiObj?.bid?.artifactid_id);
    }
    else if (simObj?.dtiObj?.quality?.isQualityIssue && simObj?.dtiObj?.quality?.artifactid_id) {
      setActiveIssue("QUALITY_ISSUE");
      !activeArtifactId && setActiveArtifactId(simObj?.dtiObj?.quality?.artifactid_id);
    }
    else if (simObj?.dtiObj?.delivery?.isDeliveryIssue && simObj?.dtiObj?.delivery?.artifactid_id) {
      setActiveIssue("DELIVERY_ISSUE");
      !activeArtifactId && setActiveArtifactId(simObj?.dtiObj?.delivery?.artifactid_id);
    }
    else if (simObj?.dtiObj?.labour?.isLabourIssue && simObj?.dtiObj?.labour?.artifactid_id) {
      setActiveIssue("LABOUR_ISSUE");
      !activeArtifactId && setActiveArtifactId(simObj?.dtiObj?.labour?.artifactid_id);
    }
    console.log(simObj?.dtiObj)
    }, [simObj?.dtiObj,activeIssue,activeArtifactId])

    useEffect(()=>{
      activeArtifactId && console.log(activeArtifactId)
    },[activeArtifactId])

  useEffect(() => {
    const ua = navigator.userAgent;
    // Detect iOS devices (including iPadOS that reports as Mac)
    const isIOS =
      /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    // Detect Android tablets (Android but not phones)
    const isAndroidTablet = /Android/.test(ua) && !/Mobile/.test(ua);
    
    if (isIOS || isAndroidTablet) {
      const popupBox = document.querySelector(
        '.ui.raised.popup-box'
      );

      if (popupBox) {
        popupBox.setAttribute('tabindex', '-1'); // 👈 make it focusable
      } 

      const dialog = document.querySelector('.email-box .popup-box[role="dialog"]');
      setTimeout(() => {
        if (dialog) {
          dialog.focus();
        }
      }, 1000);
    }
  }, []);


  return (
    <div className='ui pointing label popup-container email-box' style={{ "--left": `${popupLeft}px` }}>
      {/* <div className="polygon email"></div> */}
      <div className="ui raised very padded text container segment popup-box" role="dialog" aria-modal="true" aria-labelledby="emailModal">
        <div className="header-box">
          <div>
            <img className="image textmsg icon" src={email} alt="" />
            <h2 id="emailModal" className="title" tabindex={-1}>EMAIL INBOX</h2>
          </div>
          <div className='close-popup' onClick={closePopups}>
            <a role="button" href="#" aria-label='Close'><img src={close} alt="" /></a>
          </div>

        </div>
        <div className="section">
          {
            simObj?.artifacts?.filter((data) => data.md == "EMAILS").length > 0 ?
              (<div className="ui stackable two column grid">
                <div className="six wide column">
                  <div className="ui secondary segment">
                    <ul className="ui divided list" role="tablist" aria-label="Email tabs">
                      {simObj.artifacts.filter((data) => data.md == "EMAILS").sort((a, b) => ((b.aii < a.aii) ? -1 : 1)).sort((a, b) => (b.cr - a.cr)).map((data, index) => (
                        <li id={data.aii} key={data.aii} style={(simObj?.impArtifacts && simObj?.impArtifacts?.indexOf(data.ai) != -1) ? {paddingRight:'2px'} : {}} resourcetype={data.rt} classification={data?.val?.classification} className={`item tab-item ${(index == 0) || (data.ci == data.aii) ? 'active' : ''} ${data.rs == 1 ? 'visited' : ''}`} data-tab={"tab-" + data.aii} onClick={handleButtonClick} role='tab' onKeyDown={(e) => e.key == "Enter" && e.currentTarget.click()} tabIndex={index == 0 ? 0 : -1} aria-selected={index == 0} aria-controls={`tab_${data.aii}_tab`}>
                          <div className="content">
                            <p>
                              <span className="sr-only">
                                {data.rs == 1 ? "Visited:" : "Not Visited:"}
                              </span>
                              <p style={(simObj?.impArtifacts && simObj?.impArtifacts?.indexOf(data.ai) != -1) ? {gridTemplateColumns: '25px auto auto 16px'} : {}}>
                                <a></a>
                                <span className={`left floated ${data.rs == 0 ? 'dot' : ''}`}><span>{data.val.artifactName == '' ? "No Subject" : data.val.artifactName}</span></span>
                                <span className="right floated" style={(simObj?.impArtifacts && simObj?.impArtifacts?.indexOf(data.ai) != -1) ? {textAlign: 'center',minWidth:'auto'} : { minWidth: "50px", textAlign: "end" }}>{shortMonthNames[data.sm]} {data.sd}</span>
                                {
                                  (simObj?.impArtifacts && simObj?.impArtifacts?.indexOf(data.ai) != -1) ? <img src={info} alt="" /> :''
                                }
                              </p>
                            </p>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="ten wide column" tabIndex={-1}>
                  <div>
                    {simObj.artifacts.filter((data) => data.md == "EMAILS").sort((a, b) => ((b.aii < a.aii) ? -1 : 1)).sort((a, b) => (b.cr - a.cr)).map((data, index) => (
                      <div className={`ui tab ${index == 0 ? "active" : ""}`} key={data.aii} data-tab={"tab-" + data.aii} id={`tab_${data.aii}_tab`} role="tabpanel" aria-labelledby={data.aii} tabIndex={index == 0 ? 0 : -1} hidden>
                        <div className="content_box">
                          <div className="subject_box">
                            <p>FROM: <span>{data.val.sender}</span></p>
                            <p>SUBJECT: <span>{data.val.artifactName}</span></p>
                          </div>
                          <div className="compose_box" dangerouslySetInnerHTML={{ __html: replaceVariables(addSpaceAfterDot(data.val.value)) }}>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                {
                     (
                      (activeIssue == "BID_RESPONSE" && activeArtifactId == simObj?.dtiObj?.bid?.artifactid_id) || 
                      (activeIssue == "DELIVERY_ISSUE" && activeArtifactId == simObj?.dtiObj?.delivery?.artifactid_id) || 
                      (activeIssue == "LABOUR_ISSUE" && activeArtifactId == simObj?.dtiObj?.labour?.artifactid_id) || 
                      (activeIssue == "QUALITY_ISSUE" && activeArtifactId == simObj?.dtiObj?.quality?.artifactid_id) 
                     ) && <div className="column" style={{ "display": "flex", justifyContent: "flex-end", width: "100%", marginTop: "5px", marginRight: "20px" }}>
                    {activeIssue == "BID_RESPONSE" && simObj?.dtiObj?.bid?.isWaitForMoreBids ? <button onClick={onHandlerWaitForMoreBids} style={{...btnStyle, "margin-right":"10px"}}>WAIT FOR MORE BIDS</button> : ''}
                    {activeIssue == "BID_RESPONSE" && simObj?.dtiObj?.bid?.isBidReceived ? <button onClick={onHandlerViewBids} style={{...btnStyle}}>VIEW BIDS</button> : ''}
                    {(activeIssue == "DELIVERY_ISSUE" || activeIssue == "LABOUR_ISSUE" || activeIssue == "QUALITY_ISSUE") && simObj?.dtiObj?.delivery?.isDeliveryIssue || simObj?.dtiObj?.labour?.isLabourIssue || simObj?.dtiObj?.quality?.isQualityIssue ? (<button onClick={onHandlerContinueBid} style={{...btnStyle,"margin-right":"10px"}}>CONTINUE</button>) : ''}
                    {(activeIssue == "DELIVERY_ISSUE" || activeIssue == "LABOUR_ISSUE" || activeIssue == "QUALITY_ISSUE") &&simObj?.dtiObj?.delivery?.isDeliveryIssue || simObj?.dtiObj?.labour?.isLabourIssue || simObj?.dtiObj?.quality?.isQualityIssue? <button onClick={onHandlerCancelOrder} style={{...btnStyle}}>CANCEL ORDER</button> : ''}
                  </div>
                }
                {
                    simObj?.laststate?.randomEventOccured==1 && <div className="column" style={{ "display": "flex", justifyContent: "flex-end", width: "100%", marginTop: "5px", marginRight: "20px" }}>
                    {simObj?.laststate?.randomEventOccured==1 && <button onClick={()=>{closePopups();}} style={{...btnStyle}}>REVIEW PROJECT PLAN</button>}
                    </div>
                }
              </div>)
              :
              (<div className='empty ui stackable grid'>
                <div className="column">
                  <div className="ui info message">
                    <div className="header">
                      There are no emails for this category.
                    </div>
                  </div>
                </div>
              </div>)

          }
        </div>
      </div>
    </div>
  )
})

export default EmailInbox